module.exports = __webpack_public_path__ + "img/header-1.6e05ab45.png";